import React, { useState } from 'react';
import './App'
import './App.css';

// This is the main game code will be

const questions = [
    {
        // Question 1
        question: "What was the babie's nickname?",
        choices: ["Nick", "Jonas Jr", "Gabe"],
        rightAnswer: "Gabe",
    },
    {
        // Question 2
        question: "Who named Gabirel",
        choices: ["Jonas's Father", "Asher", "Lily"],
        rightAnswer: "Jonas's Father",
    },
    {
        // Question 3
        question: "Jonas was given a full number at birth, what was it?",
        choices: ["11-20", "12-09", "11-19"],
        rightAnswer: "11-19",
    },
    {
        // Question 4
        question: "'Jonas has been selected to be our next... '",
        choices: ["Receiver", "Receiver of Memory", "Pilot"],
        rightAnswer: "Receiver of Memory",
    },
    {
        // Question 5
        question: "How many rules did Jonas have when he looked into his folder as the Receiver of Memory?",
        choices: ["12", "8", "7"],
        rightAnswer: "8",
    },
    {
        // Question 6
        question: "What was Jonas allowed to do after being selected for The Reciever",
        choices: ["Lie", "Eat more food", "Read more books"],
        rightAnswer: "Lie",
    },
    
    {
        // Question 7
        question: "How did Jonas react when The Giver told him to remember riding a sled, being on top of a hill?",
        choices: ["Sorry?", "Excuse me?", "I beg your pardon?"],
        rightAnswer: "Excuse Me?",
    },

];

export default function Game() {
    const [score, setScore] = useState(0);
    const [questionIndex, setQuestionIndex] = useState(0);
    const [answer, setAnswer] = useState("");

    const restart = () => {
        setScore(0);
        setAnswer("");
        setQuestionIndex(0);
    };

    const submit = (e: any) => {
        e.preventDefault();
        if (answer === questions[questionIndex].rightAnswer) {
            setScore((score) => score + 1);
        }

        if (questionIndex < questions.length) {
            setQuestionIndex((i) => i + 1);
        }
    };

    const quotes = [
        " Question 1: 'I call him Gabe, actually, he said, and grinned.' pg. 12' ",
        " Question 2: 'His father nodded 'His name --- if he makes it to the Naming without being released, of course -- is to Gabriel.' pg. 12' ",
        " Question 3: 'Technically, Jonas's full number was Eleven-nineteen, since there were other Nineteens, of course, in each age group.' pg. 50-51 ",
        " Question 4: 'Jonas has been selected to be our next Receiver of Memory.' pg. 60 ",
        " Question 5: There is a lot of text so here is the page number so you can find it... pg. 68 ",
        " Question 6: '8. You may Lie.' pg. 68 ",
        " Question 7: 'Jonas was puzzled. He opened his eyes. 'Excuse me,' he asked politely.' pg. 93 ",
    ];

    // Displays Question
    if (questionIndex < questions.length) {
        return (
            <div className='Quiz'>
                <label>{questions[questionIndex].question}</label>
                {questions[questionIndex].choices.map((c, i) => {
                    return (
                        <div className='questions'>
                            <input
                                type="radio"
                                name="choice"
                                value={c}
                                onChange={(e) => setAnswer(e.target.value)}
                                checked={answer === c}
                            />
                            {c}
                        </div>
                    );
                })}
                <button className='check__button' type="button" onClick={submit}>
                    check
                </button>
                <p className='score'>score: {score}</p>
            </div>
        );
    } else {
        return (
            <>
                <form className='Quiz'>
                    <h3>Thank you for playing!</h3>
                    <div v-else>
                        <button className='check__button' type="button" onClick={restart}>
                            restart
                        </button>
                    </div>
                    <p className='score'>score: {score}</p>
                </form>
                <p className='quotes'>{quotes}</p>
            </>
        );
    }
}